import './input-validation.scss';

import * as gzInputValidationDirective from './input-validation.directive';

export default angular.module('gazelle.components.input-validation', [])
  .directive(gzInputValidationDirective.name, gzInputValidationDirective.default)
  .name;
